import { usePlatformAdmin } from '@/hooks/use-platform-admin';
import { NotFoundPage } from '@/pages/NotFoundPage';

export function AdminGuard({ children }: { children: React.ReactNode }) {
  const { isAdmin, isLoading } = usePlatformAdmin();
  if (isLoading) return null;
  if (!isAdmin) return <NotFoundPage />;
  return <>{children}</>;
}
